import React, {FC, useMemo} from "react";
import {
    BottomGroup,
    DateText
} from "../styles";
import {useTranslation} from "react-i18next";
import {getFormattedDate} from "../../../helpers/getFormattedDate";

export const NotificationBottomDate: FC<{item: any}> = ({item}) => {

    const {
        dateCreated,
    } = item;

    const { i18n: { language } } = useTranslation();

    const formattedDate = useMemo(() => getFormattedDate(dateCreated, language), [dateCreated, language])

    return <BottomGroup>
        <DateText>
            {formattedDate}
        </DateText>
    </BottomGroup>
}import React, {FC, useMemo} from "react";
import {
    BottomGroup,
    DateText
} from "../styles";
import {useTranslation} from "react-i18next";
import {getFormattedDate} from "../../../helpers/getFormattedDate";

export const NotificationBottomDate: FC<{item: any}> = ({item}) => {

    const {
        dateCreated,
    } = item;

    const { i18n: { language } } = useTranslation();

    const formattedDate = useMemo(() => getFormattedDate(dateCreated, language), [dateCreated, language])

    return <BottomGroup>
        <DateText>
            {formattedDate}
        </DateText>
    </BottomGroup>
}